/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'info': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(8 8)" _stroke="#00272E"><ellipse pid="0" cx="8.5" cy="8.131" rx="8.5" ry="8.13"/><path pid="1" d="M8.5 11.826a.19.19 0 00-.193.185.19.19 0 00.193.185.19.19 0 00.193-.185.19.19 0 00-.193-.185"/><path pid="2" d="M6.182 6.656c0-1.108.854-2.045 2.001-2.196 1.147-.152 2.235.53 2.549 1.596.313 1.066-.244 2.19-1.305 2.632a1.478 1.478 0 00-.927 1.355v.305"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/info.js